import { combineReducers } from "redux";
import form from "./form/form.reducer";

const review = combineReducers({
  form,
});

export default review;
